function findButtonWithText(text, selector) {
    const $ = jQuery.noConflict();
    if (selector === undefined) {
        selector = '.button';
    }
    const found = [];

    $(selector + ':visible').each(function() {
        if ($(this).text() === text || $(this).attr('value') !== undefined && $(this).attr('value') === text) {
            if ($(this).parents('.scroll-screen').length === 0 || $(this).parents('.scroll-screen').hasClass('active')) {
                if ($(this).attr('id') === undefined) {
                    $(this).attr('id', get_unique_id());
                }
                if ($('*#' + $(this).attr('id')).length > 1) {
                    // there are more items with the same id on screen, fix this
                    $(this).attr('data-original-id', $(this).attr('id'));
                    $(this).attr('id', get_unique_id());
                }
                found.push($(this));
            }
        }
    });
    if (found.length === 0) {
        return [];
    }
    const first_found = found[0];
    const args = {id: first_found.attr('id')};
    if (first_found.attr('data-original-id') !== undefined) {
        args['original_id'] = first_found.attr('data-original-id');

        first_found.bind('click.foundButton', function() {
            $(this).unbind('click.foundButton');
            $(this).attr('id', $(this).attr('data-original-id'));
            $(this).removeAttr('data-original-id');
            console.log($(this));
        })
    }
    return args;
}